import { useConfig } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Box, Checkbox, Inline, MonthPicker } from 'braid-design-system';
import type { MonthPickerValue, QuestionProps } from '../../../type';
import translations from './.vocab';
import { getMonthAbbreviations } from './utils';
import * as styles from './WorkHistoryQuestion.css';

type FinishQuestionProps = QuestionProps<MonthPickerValue> & {
  isStillWorkHere: boolean;
  onIsStillWorkHereChange: () => void;
};

export const FinishQuestion = ({
  value,
  message,
  tone,
  isStillWorkHere,
  onChange,
  onIsStillWorkHereChange,
}: FinishQuestionProps) => {
  const { t } = useTranslations(translations);
  const { locale } = useConfig();

  const months = getMonthAbbreviations(locale);

  return (
    <Inline collapseBelow="tablet" alignY="center" space="medium">
      <Box
        className={[
          isStillWorkHere
            ? styles.monthPickerInvisible
            : styles.monthPickerTransition,
          styles.monthPickerWidth,
        ]}
      >
        <MonthPicker
          id="whenFinish"
          label={t('When did you finish')}
          onChange={onChange}
          value={value ?? {}}
          monthNames={months}
          reserveMessageSpace
          message={message}
          tone={tone}
          monthLabel={t('Month')}
          yearLabel={t('Year')}
        />
      </Box>
      <Box
        className={[
          styles.checkBox,
          isStillWorkHere ? styles.checkBoxTransition : undefined,
        ]}
        paddingBottom={{
          mobile: 'medium',
          tablet: 'none',
        }}
      >
        <Checkbox
          id="stillWorkHere"
          label={t('I still work here')}
          checked={Boolean(isStillWorkHere)}
          onChange={onIsStillWorkHereChange}
        />
      </Box>
    </Inline>
  );
};
